export default {
    status_no: '403',
    name: 'Доступ запрещен',
    message: 'Доступ к этому ресурсу на сервере запрещен',
}
